import * as React from "react"

import { TimeOutline } from "@behaviour-lab/blab-component-library"

import { VALUE_CREATION_OVER_TIME_ROUTE } from "../routes"

type IconProps = {
  className?: string
}

const valueCreationOverTimeLink = {
  label: "Value Creation Over Time",
  to: VALUE_CREATION_OVER_TIME_ROUTE,
  Icon: ({ className }: IconProps) => <TimeOutline className={className} />,
}

export default valueCreationOverTimeLink
